export default {
  
    Settings: 'Setting|Settings',
};
